import Input from 'react-phone-number-input/input';
import { FieldRequiredIndicator, Error } from '../common';
import { styled } from '@mui/material';

export function Phone({
  phoneFromDetails,
  onChange,
}: {
  phoneFromDetails: string | null;
  onChange: (value?: string) => void;
}) {
  return (
    <>
      <Labe>
        Phone <FieldRequiredIndicator /> :
      </Labe>

      <Input
        country="US"
        value={phoneFromDetails || void 0}
        onChange={onChange}
        id={`phone`}
      />
      {(phoneFromDetails || '').length > 12 && (
        <>
          <label></label>
          <Error>Phone number is invalid.</Error>
        </>
      )}
    </>
  );
}

const Labe = styled('label')(({ theme }) => ({ fontWeight: 700 }));
